<template>
  <div>
    <!-- 上传控件 -->
    <el-upload
      class="upload-demo"
      :action="uploadUrl"
      :data="uploadData"
      name="file"
      v-if="!disabled"
      accept=".png, .jpg, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .msg, .py, .mp4, .avi, .mp3, .amr, .wav, .jpg, .JPG, .png, .PNG, .jpeg, .rar, .pdf, .PDF, .zip, .ZIP, .7z, .csv, .txt"
      :multiple="true"
      :before-remove="beforeRemoveUploadFile"
      :with-credentials="true"
      :show-file-list="false"
      :on-success="uploadSuccess"
      :disabled="disabled"
      :before-upload="beforeUpload"
    >
      <slot></slot>
      <el-button
        :disabled="false"
        v-show="showUploadButton"
        
        type="primary"
        v-if="!disabled"
        slot="trigger"
        :plain="isPlain"
        :style="{ width: buttonWidth }"
        >{{ language ? '点击上传' : 'Click To Upload' }}</el-button
      >
      <span
        v-show="showUploadButton"
        slot="tip"
        class="el-upload__tip"
        v-if="!disabled"
        style="margin: 50px; cursor: pointer"
      >
        <span v-if="language">
          <span style="font-size: 16px"
            >只能上传.doc, .docx, .xls, .xlsx, .ppt, .pptx，图片，视频，音频文件，且不超过</span
          >
          <span style="font-size: 16px; font-weight: 800; color: #ff0000d4">50Mb</span>
        </span>
        <span v-else>
          <span style="font-size: 16px"
            >Only. doc,. docx,. xls,. xlsx,. ppt,. pptx, images, videos, audio files can be uploaded, and they should
            not exceed</span
          >
          <span style="font-size: 16px; font-weight: 800; color: #ff0000d4">50Mb</span>
        </span>
      </span>
    </el-upload>
    <el-table
      v-if="showUploadTable"
      v-loading="loading"
      :data="uploadedFileList"
      border
      :show-header="showTableHeader"
      stripe
      :header-cell-style="tableheaderclass"
      style="width: 100%"
    >
      <el-table-column prop="fileName" :label="language ? '文件名称' : 'File Name'" />
      <el-table-column
        v-if="!simple"
        prop="creatorName"
        :label="language ? '创建人' : 'Uploader'"
        width="160px"
        align="center"
      />
      <el-table-column
        v-if="!simple"
        prop="created"
        :label="language ? '创建时间' : 'Upload Time'"
        width="200px"
        align="center"
      >
        <template slot-scope="scope">{{ scope.row.created | formatDate }}</template>
      </el-table-column>
      <!-- <el-table-column width="80px">
        <template slot-scope="scope">
          <el-button  type="text">
            <a v-if="scope.row.pdfUrl!=''" :href="scope.row.pdfUrl" target="_blank">{{language?'原预览':'Preview'}}</a>
          </el-button>
        </template>
      </el-table-column> -->
      <el-table-column width="400px" :label="language ? '操作' : 'Operation'" align="center">
        <template slot-scope="scope">
          <el-button
            class="upload_operation_button"
            :disabled="false"
            
            type="text"
            @click="bsOffice.read(scope.row.guid, scope.row.fileName)"
          >
            {{ language ? '预览' : 'Preview' }}
          </el-button>
          <el-button
            class="upload_operation_button"
            :disabled="false"
            
            type="text"
            @click="showReName(scope.row)"
            v-if="!disabled"
          >
            {{ language ? '重命名' : 'ReName' }}
          </el-button>
          <el-button
            class="upload_operation_button"
            :disabled="false"
            
            type="text"
            @click="bsOffice.edit(scope.row.guid, scope.row.fileName)"
            v-if="hasEdit && bsEditDisable"
          >
            {{ language ? '编辑' : 'Edit' }}
          </el-button>
          <el-button
            class="upload_operation_button"
            :disabled="false"
            
            type="text"
            @click="down(scope.row.guid, scope.row.fileName)"
          >
            {{ language ? '下载' : 'DownLoad' }}
          </el-button>
          <el-button
            class="upload_operation_button"
            :disabled="false"
            
            type="text"
            style="color: red"
            @click="beforeRemoveUploadFile(scope.row.guid)"
            v-if="!disabled"
            >{{ language ? '删除' : 'Delete' }}</el-button
          >
        </template>
      </el-table-column>
      <!-- <el-table-column width="80px" v-if="!disabled">
        <template slot-scope="scope">
          <el-button :disabled="false"  type="text" @click="bsOffice.delete(scope.row.guid,scope.row.fileName)">
            {{language?'删除':'Delete'}}
          </el-button>
        </template>
      </el-table-column> -->
      <!-- <el-table-column width="80px">
        <template slot-scope="scope">
          <el-button  type="text">
            <a href="#" @click="download(scope.row.guid,scope.row.fileName)">{{language?'原下载':'DownLoad'}}</a>
          </el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <el-dialog title="文件重命名" :visible.sync="reNameShow" append-to-body width="350px" top="40vh">
      <el-input v-model="curReNameFile.curFileName">
        <template slot="append">{{ curReNameFile.fileSuffix }}</template>
      </el-input>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="reName">确定</el-button>
        <el-button @click="reNameShow = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Config from '@/components/Config.vue'
import DateUtils from '@/plugins/DateUtils.vue'
import * as bsOffice from '@/utils/bsOffice.js'
export default {
  // props:["upload"],
  data() {
    return {
      bsOffice: {},
      ids: [],
      curReNameFile: {},
      reNameShow: false,
      startUpload: false,
      isAdmin: false,
      loading: false,
      showUploadTable: false,
      uploadedFileList: [],
      uploadData: {
        tenant: 'portal',
        name: '',
        description: ''
      },
      uploadUrl: Config.apiUrl + '/api/store/v0.1/upload/'
    }
  },
  // directives: {
  //   uploadListDiv: {
  //     componentUpdated: function (el, bindings, vnode) {
  //       const dealStyle = function (tags) {
  //         tags.forEach((el, index) => {
  //
  //           if (![el.classList].includes("el-upload-list__item-download")) {
  //             let href=this.uploadedFileList[index].guid;
  //             let a= document.createElement("a");
  //             a.setAttribute("href","test");
  //             a.setAttribute("target","_blank");
  //             a.innerHTML="下载"

  //             let elName= el.querySelector('.el-upload-list__item-name')
  //             //
  //             el.insertBefore(a, elName.nextSibling)
  //             el.classList.add("el-upload-list__item-download");

  //           }
  //         });
  //       };
  //       setTimeout(() => {
  //         const tagTemp = el.querySelectorAll(".el-upload-list__item");
  //         dealStyle(tagTemp);
  //       });
  //     },
  //   },
  // },
  props: {
    buttonWidth: {
      type: String
    },
    isPlain: {
      type: Boolean,
      default: false
    },
    onlyDeleteValue: {
      type: Boolean,
      default: false
    },
    showTableHeader: {
      type: Boolean,
      default: true
    },
    simple: {
      type: Boolean,
      default: false
    },
    showUploadButton: {
      type: Boolean,
      default: true
    },
    hasEdit: {
      type: Boolean,
      default: false
    },
    bsEditDisable: {
      type: Boolean,
      default: false
    },
    fileIds: Array,
    value: '',
    disabled: {
      type: Boolean,
      default: false
    },
    language: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.bsOffice = bsOffice
  },
  mounted() {
    // this.getUploadFileList();
    this.isAdmin = this.Cookie.get('isAdmin')
  },
  methods: {
    tableheaderclass({ row, column, rowIndex, columnIndex }) {
      return 'background-color:#f8f9fb;font-weight:700'
    },
    showReName(item) {
      let data = Object.assign({}, item)
      data.curFileName = data.fileName
      if (data.fileName && data.fileName.indexOf('.') > -1) {
        data.curFileName = data.fileName.substr(0, data.fileName.lastIndexOf('.'))
        data.fileSuffix = data.fileName.substr(data.fileName.lastIndexOf('.'), data.fileName.length)
      }
      this.$set(this, 'curReNameFile', data)
      this.reNameShow = true
    },
    reName() {
      if (!this.curReNameFile.curFileName) {
        return this.$message.error('请填写文件名称')
      }
      this.$axios
        .post('/api/store/v0.1/update', {
          guid: this.curReNameFile.guid,
          fileName: this.curReNameFile.curFileName + this.curReNameFile.fileSuffix
        })
        .then((res) => {
          this.$message.success('文件重命名成功')
          this.getUploadFileList()
          this.reNameShow = false
        })
    },
    beforeUpload(file) {
      this.startUpload = true
      this.showUploadTable = true
      this.loading = true
    },
    //File upload successfull
    async uploadSuccess(response, file, uploadedFileList) {
      this.loading = false
      if (response.errcode == 0) {
        let res = response.data
        this.ids.push(res.guid)
        this.$emit('getUploadFileIds', this.ids)
        this.$emit('uploadFilesSuccess', res.guid, file.name)
        await this.getUploadFileList()
        this.$message.success(file.name + '上传成功。')
      } else {
        let fileNew = {}
        fileNew.name = file.name
        fileNew.guid = ''
        this.uploadedFileList.push(fileNew)
        this.uploadedFileList.pop()
        this.$message.error('上传失败:' + response.errmsg)
      }
    },
    //File Delete
    beforeRemoveUploadFile(guid) {
      if (this.onlyDeleteValue) {
        this.$confirm('此操作将删除该数据，保存后生效, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            if (this.ids.indexOf(guid) > -1) {
              this.ids.splice(this.ids.indexOf(guid), 1)
            }
            for (var i = 0; i < this.uploadedFileList.length; i++) {
              if (this.uploadedFileList[i].guid == guid) {
                this.uploadedFileList.splice(i, 1)
              }
            }
            this.$emit('getUploadFileIds', this.ids)
            if (this.uploadedFileList.length <= 0) {
              this.showUploadTable = false
            }
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        return false
      } else {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.removeUploadFile(guid)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        return false
      }
    },
    //File confirm deleteFile
    removeUploadFile(guid) {
      this.$axios.post('/api/store/v0.1/delete', 'tenant=portal&guid=' + guid).then((res) => {
        var js = res.data

        if (js.errcode == 0) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          if (this.ids.indexOf(guid) > -1) {
            this.ids.splice(this.ids.indexOf(guid), 1)
          }
          for (var i = 0; i < this.uploadedFileList.length; i++) {
            if (this.uploadedFileList[i].guid == guid) {
              this.uploadedFileList.splice(i, 1)
            }
          }
          this.$emit('getUploadFileIds', this.ids)
          bsOffice.deleteFile(guid)
          if (this.uploadedFileList.length <= 0) {
            this.showUploadTable = false
          }
        } else {
          this.$message({
            showClose: true,
            message: js.errmsg,
            type: 'error'
          })
        }
      })
    },
    //File getList
    async getUploadFileList() {
      // alert(exclude+"__"+this.ids.join(','))
      this.loading = true
      // alert(JSON.stringify(this.fileIds))
      if (this.ids.length === 0) {
        this.uploadedFileList = []
        this.loading = false
        this.showUploadTable = false
        return false
      }

      await this.$axios
        .get('/api/store/v0.1/getUploadList', {
          params: {
            tenant: 'portal',
            fileIds: this.ids.join(',')
          }
        })
        .then((res) => {
          var js = res.data
          this.loading = false
          if (js.errcode == 0) {
            this.uploadedFileList = js.data.map((item) => {
              if (item.pdfPath) {
                item.pdfUrl =
                  Config.portalUrl +
                  '/static/pdfjs-3/web/viewer.html?file=' +
                  encodeURIComponent(Config.portalUrl + '/upload/audit/' + item.pdfPath)
              }
              return item
            })
            if (!this.startUpload) {
              let ids = this.uploadedFileList.map((item) => {
                return item.guid
              })
              if (JSON.stringify(this.ids) != JSON.stringify(ids)) {
                this.ids = ids
              }
            }
            if (this.uploadedFileList.length > 0) {
              this.showUploadTable = true
            }
            console.log(this.uploadedFileList)
            this.$emit('getUploadFileIds', this.ids)
          } else {
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: 'error'
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    //File Preview
    down(guid, fileName) {
      if (this.bsEditDisable) {
        bsOffice.down(guid, fileName)
      } else {
        this.download(guid, fileName)
      }
    },
    download(guid, fileName) {
      this.$axios
        .post('/api/store/v0.1/download', 'tenant=portal&guid=' + guid, {
          responseType: 'blob'
        })
        .then((res) => {
          if (res.status == 200) {
            let url = window.URL.createObjectURL(new Blob([res.data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName) // 自定义下载文件名（如exemple.txt）
            document.body.appendChild(link)
            link.click()
          }
        })
    },
    uploadBlobToFile(blob, fileName, callBack, cover = false) {
      const formData = new FormData()
      formData.append('tenant', 'portal')
      formData.append('file', new File([blob], fileName))
      formData.append('name', '')
      formData.append('description', '')
      this.$axios
        .post(this.uploadUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          let res = response.data.data
          if (cover) {
            this.ids = [res.guid]
          } else {
            this.ids.push(res.guid)
          }
          this.$emit('getUploadFileIds', this.ids)
          this.$emit('uploadFilesSuccess', res.guid, fileName)
          this.getUploadFileList()
          callBack()
        })
    }
  },
  watch: {
    fileIds: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log('Upload.fileIds:', val)
        if (val) {
          this.ids = this.fileIds
        }
        this.getUploadFileList()
      }
    },
    value: {
      deep: true,
      immediate: true,
      async handler(val, old) {
        if (val != old && this.$listeners.input) {
          if (val) {
            this.ids = val.split(',')
          } else {
            this.ids = []
          }
          this.getUploadFileList()
          // if(val&&!old){
          // 	let ids = this.uploadedFileList.map(item=>{
          // 		return item.guid
          // 	})
          // 	if(JSON.stringify(this.ids)!=JSON.stringify(ids)){
          // 		this.ids = ids
          // 	}
          // }
        }
      }
    },
    ids(val) {
      if (val && val.length > 0) {
        this.$emit('input', val.join(','))
      } else {
        this.$emit('input', '')
      }
    }
  },
  filters: {
    formatDate(time) {
      return DateUtils.formatDate(time, 'YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style>
.el-upload-list__item-name {
  float: left;
}
.el-table__header tr,
.el-table__header th {
  height: 20px;
  line-height: 20px;
}
.showT {
  display: block;
}
.hiddT {
  display: none;
}
.upload_operation_button {
  margin: 0 20px;
}
</style>
